/**
 * Media Library Page - Clean Design
 */

import { useState } from 'react';

export function Media() {
    const [view, setView] = useState<'grid' | 'list'>('grid');

    return (
        <div className="animate-fade-in max-w-6xl mx-auto space-y-8">
            {/* Header */}
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                <div>
                    <h1 className="text-2xl font-bold" style={{ color: 'var(--text-primary)' }}>
                        Media Library
                    </h1>
                    <p style={{ color: 'var(--text-secondary)' }}>
                        Organize and manage your digital assets
                    </p>
                </div>
                <div className="flex items-center gap-3">
                    <button className="btn btn-secondary px-6">
                        Import URL
                    </button>
                    <button className="btn btn-primary px-8">
                        Upload Files
                    </button>
                </div>
            </div>

            {/* Browser Interface */}
            <div className="card overflow-hidden">
                {/* Filters Toolbar */}
                <div
                    className="p-4 flex flex-col md:flex-row items-center justify-between gap-4"
                    style={{ backgroundColor: 'var(--bg-secondary)', borderBottom: '1px solid var(--border-color)' }}
                >
                    <div className="flex items-center gap-4 w-full md:w-auto">
                        <div className="relative flex-1 md:flex-none">
                            <input
                                type="text"
                                placeholder="Search assets..."
                                className="input pl-9 w-full md:w-64"
                                style={{ backgroundColor: 'var(--bg-primary)' }}
                            />
                            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm" style={{ color: 'var(--text-muted)' }}>🔍</span>
                        </div>
                        <select className="input w-auto text-sm" style={{ backgroundColor: 'var(--bg-primary)' }}>
                            <option value="">All Types</option>
                            <option value="images">Images</option>
                            <option value="audio">Audio</option>
                            <option value="videos">Videos</option>
                            <option value="docs">Documents</option>
                        </select>
                    </div>

                    <div className="flex items-center gap-2">
                        <div className="flex bg-opacity-10 rounded-lg p-1" style={{ backgroundColor: 'var(--bg-tertiary)' }}>
                            <button
                                onClick={() => setView('grid')}
                                className={`w-9 h-9 flex items-center justify-center rounded-md transition-all ${view === 'grid' ? 'bg-primary-500 text-white shadow-sm' : ''
                                    }`}
                                style={{ backgroundColor: view === 'grid' ? 'var(--accent)' : 'transparent', color: view === 'grid' ? 'white' : 'var(--text-secondary)' }}
                            >
                                ▦
                            </button>
                            <button
                                onClick={() => setView('list')}
                                className={`w-9 h-9 flex items-center justify-center rounded-md transition-all ${view === 'list' ? 'bg-primary-500 text-white shadow-sm' : ''
                                    }`}
                                style={{ backgroundColor: view === 'list' ? 'var(--accent)' : 'transparent', color: view === 'list' ? 'white' : 'var(--text-secondary)' }}
                            >
                                ☰
                            </button>
                        </div>
                    </div>
                </div>

                {/* Content Area */}
                <div className="p-12 text-center min-h-[400px] flex flex-col items-center justify-center">
                    <div
                        className="w-24 h-24 rounded-3xl mb-6 flex items-center justify-center text-5xl"
                        style={{ backgroundColor: 'var(--bg-secondary)' }}
                    >
                        📁
                    </div>
                    <h3 className="text-xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
                        No files here yet
                    </h3>
                    <p className="max-w-xs mx-auto mb-8" style={{ color: 'var(--text-secondary)' }}>
                        Drop your files here, or use the upload button to sync with Cloudflare R2 storage.
                    </p>
                    <button className="btn btn-primary px-8 py-3 font-bold shadow-lg shadow-blue-500/20">
                        Upload First Asset
                    </button>
                </div>
            </div>

            {/* Quick Stats Placeholder */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div className="card p-4 flex gap-4 items-center">
                    <div className="text-2xl">🖼️</div>
                    <div>
                        <div className="text-xs font-bold uppercase tracking-tighter" style={{ color: 'var(--text-muted)' }}>Images</div>
                        <div className="font-bold" style={{ color: 'var(--text-primary)' }}>0</div>
                    </div>
                </div>
                <div className="card p-4 flex gap-4 items-center">
                    <div className="text-2xl">🎵</div>
                    <div>
                        <div className="text-xs font-bold uppercase tracking-tighter" style={{ color: 'var(--text-muted)' }}>Audio</div>
                        <div className="font-bold" style={{ color: 'var(--text-primary)' }}>0</div>
                    </div>
                </div>
                <div className="card p-4 flex gap-4 items-center">
                    <div className="text-2xl">📹</div>
                    <div>
                        <div className="text-xs font-bold uppercase tracking-tighter" style={{ color: 'var(--text-muted)' }}>Video</div>
                        <div className="font-bold" style={{ color: 'var(--text-primary)' }}>0</div>
                    </div>
                </div>
                <div className="card p-4 flex gap-4 items-center">
                    <div className="text-2xl">📊</div>
                    <div>
                        <div className="text-xs font-bold uppercase tracking-tighter" style={{ color: 'var(--text-muted)' }}>Used Space</div>
                        <div className="font-bold" style={{ color: 'var(--text-primary)' }}>0 KB / 10 GB</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
